'use client';

import { IconArrowSmallLeft } from '@/icons/IconArrowSmallLeft';
import { IconArrowSmallRight } from '@/icons/IconArrowSmallRight';
import { twMerge } from 'tailwind-merge';

const CustomButtonGroupAsArrows = ({
  next,
  previous,
  goToSlide,
  swiper,
  isTestimonial = false,
  dataTestId = 'custom-button-group',
  className = 'hidden lg:block',

  ...rest
}: any) => {
  return (
    <div className={twMerge(`whitespace-nowrap`, className, isTestimonial ? 'space-x-3' : '')} data-testid={dataTestId}>
      <ArrowButton
        isTestimonial={isTestimonial}
        onClick={() => {
          swiper.slidePrev();
        }}
        dataTestId={`${dataTestId}-prev`}
      >
        <IconArrowSmallLeft className="h-6 w-6" data-testid={`${dataTestId}-prev-icon`} />
      </ArrowButton>

      <ArrowButton
        isTestimonial={isTestimonial}
        onClick={() => {
          swiper.slideNext();
        }}
        dataTestId={`${dataTestId}-next`}
      >
        <IconArrowSmallRight className="h-6 w-6" data-testid={`${dataTestId}-next-icon`} />
      </ArrowButton>
    </div>
  );
};

export default CustomButtonGroupAsArrows;

const ArrowButton = ({ onClick, className, children, dataTestId, isTestimonial }: any) => {
  return (
    <button onClick={onClick} className={`rounded-none p-0 ${className} cursor-pointer bg-transparent`} data-testid={dataTestId}>
      <div
        className={twMerge(
          'm-0 flex items-center justify-center rounded-none transition-all duration-300 ease-in hover:bg-black hover:text-white md:h-14 md:w-14',
          isTestimonial ? 'h-10 w-10 bg-black text-white' : 'h-14 w-14 text-black',
        )}
      >
        {children}
      </div>
    </button>
  );
};
